/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkUploadDocument
 */
export interface BulkUploadDocument {
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    s3_key: string;
}

/**
 * Check if a given object implements the BulkUploadDocument interface.
 */
export function instanceOfBulkUploadDocument(value: object): value is BulkUploadDocument {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('s3_key' in value) || value['s3_key'] === undefined) return false;
    return true;
}

export function BulkUploadDocumentFromJSON(json: any): BulkUploadDocument {
    return BulkUploadDocumentFromJSONTyped(json, false);
}

export function BulkUploadDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUploadDocument {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        's3_key': json['s3_key'],
    };
}

export function BulkUploadDocumentToJSON(json: any): BulkUploadDocument {
    return BulkUploadDocumentToJSONTyped(json, false);
}

export function BulkUploadDocumentToJSONTyped(value?: BulkUploadDocument | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        's3_key': value['s3_key'],
    };
}

